export default "__VITE_ASSET__JKh89L$w__"